"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5030],{

/***/ 66660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ScrollToViewport; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _react_hook_merged_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27006);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30644);



var ScrollToViewport = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function ScrollToViewport(param, ref) {
    var children = param.children, active = param.active, options = param.options, scrollOnMount = param.scrollOnMount;
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var mergedRef = (0,_react_hook_merged_ref__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref, scrollRef);
    var hasChildren = !!children;
    var isFirstMount = (0,react_use__WEBPACK_IMPORTED_MODULE_2__/* .useFirstMountState */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((scrollOnMount || !isFirstMount) && active && hasChildren) {
            var _$ref;
            (_$ref = scrollRef.current) === null || _$ref === void 0 ? void 0 : _$ref.scrollIntoView(options !== null && options !== void 0 ? options : {
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        active,
        hasChildren
    ]);
    return children && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: mergedRef
    });
});


/***/ }),

/***/ 26026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FilterType; }
/* harmony export */ });
var FilterType;
(function(FilterType) {
    FilterType["Multiselect"] = "multiselect";
    FilterType["Tags"] = "tags";
    FilterType["SearchInput"] = "searchinput";
    FilterType["Language"] = "language";
    FilterType["Facepart"] = "facepart";
})(FilterType || (FilterType = {}));


/***/ }),

/***/ 15030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ ShowcasePageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/modules/videos/hooks/useVideosListQuery.ts
var useVideosListQuery = __webpack_require__(24332);
// EXTERNAL MODULE: ./src/modules/user/hooks/useFavouriteVideosQuery.ts
var useFavouriteVideosQuery = __webpack_require__(26160);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/renderers/SliderSectionRender.tsx
var SliderSectionRender = __webpack_require__(86649);
// EXTERNAL MODULE: ./src/modules/videos/graphql/videos-basic.query.ts
var videos_basic_query = __webpack_require__(77336);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/containers/VideoFavouritesContainer.tsx








var VideoFavouritesContainer = function(param) {
    var section = param.section;
    var favoriteVideos = (0,useFavouriteVideosQuery/* useFavoriteVideosQuery */.vS)();
    var favoriteVideosIds = favoriteVideos.data;
    var _data;
    var videos = (0,useVideosListQuery/* useVideosListQuery */.L)(videos_basic_query/* videosBasicGqlQuery */.g, {
        filters: {
            id: {
                _in: (_data = favoriteVideos.data) !== null && _data !== void 0 ? _data : []
            },
            status: {
                _eq: "published"
            }
        },
        limit: 10
    }, {
        enabled: !!favoriteVideosIds
    });
    return (favoriteVideosIds === null || favoriteVideosIds === void 0 ? void 0 : favoriteVideosIds.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderSectionRender/* SliderSectionRender */.t, {
        section: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
            variables: {
                limit: 10,
                itemsToQuery: [
                    "videos"
                ]
            }
        }),
        items: videos.data,
        isLoading: videos.isLoading
    }) : null;
};

// EXTERNAL MODULE: ./src/hooks/dev/useFastRefreshFixer.tsx
var useFastRefreshFixer = __webpack_require__(78162);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/common.tsx
var common = __webpack_require__(52178);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/components/icons/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(18709);
// EXTERNAL MODULE: ./src/components/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(38108);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/modules/home/components/HomeBusinessCasesSection/Showcase.tsx
var Showcase = __webpack_require__(45499);
// EXTERNAL MODULE: ./src/modules/home/hooks/useBusinessCasesVideosQuery.ts + 1 modules
var useBusinessCasesVideosQuery = __webpack_require__(79429);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./src/components/common/Skeleton.tsx
var Skeleton = __webpack_require__(47536);
// EXTERNAL MODULE: ./src/hooks/useIsRTL.ts + 1 modules
var useIsRTL = __webpack_require__(36311);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/containers/BusinessCasesContainer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120px;\n  height: 269px;\n\n  ",
        " {\n    width: 180px;\n    height: 401px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: var(--results-left-margin);\n  padding-right: calc(var(--constraint-container-right-margin) - 20px);\n  margin-bottom: 42px;\n\n  ",
        " {\n    padding-right: var(--results-left-margin);\n    padding-left: calc(var(--constraint-container-right-margin) - 20px);\n  }\n\n  ",
        " {\n    margin-bottom: 40px;\n  }\n\n  .swiper-slide {\n    position: relative;\n    margin-right: 8px;\n    background: ",
        ";\n    ",
        " {\n      margin-right: 0;\n      margin-left: 8px;\n    }\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  margin: 0 calc(-1 * var(--results-right-margin)) 0\n    calc(-1 * var(--results-left-margin));\n\n  ",
        " {\n    margin: 0 calc(-1 * var(--results-left-margin)) 0\n      calc(-1 * var(--results-right-margin));\n  }\n\n  min-height: 269px;\n\n  ",
        " {\n    min-height: 401px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        " {\n    opacity: 0;\n  }\n  &:hover > ",
        " {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    top: 50%;\n    transform: translateY(-50%);\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



















var businessCaseElement = (0,styled_components_browser_esm.css)(_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var VideoSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "BusinessCasesContainer__VideoSwiper",
    componentId: "sc-727439f0-0"
})(_templateObject1(), theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, theme/* dirRTL */.gX, businessCaseElement);
var SmallerShowcase = (0,styled_components_browser_esm["default"])(Showcase/* Showcase */.$m).withConfig({
    displayName: "BusinessCasesContainer__SmallerShowcase",
    componentId: "sc-727439f0-1"
})(_templateObject2(), businessCaseElement);
var SwiperArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BusinessCasesContainer__SwiperArea",
    componentId: "sc-727439f0-2"
})(_templateObject3(), theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var SwiperContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BusinessCasesContainer__SwiperContent",
    componentId: "sc-727439f0-3"
})(_templateObject4(), common/* NavigationButton */.W, common/* NavigationButton */.W);
var StyledNavigationButton = (0,styled_components_browser_esm["default"])(common/* NavigationButton */.W).withConfig({
    displayName: "BusinessCasesContainer__StyledNavigationButton",
    componentId: "sc-727439f0-4"
})(_templateObject5());
var BusinessCasesContainer = function(param) {
    var section = param.section;
    var key = (0,useFastRefreshFixer/* useFastRefreshFixer */.P)();
    var prevRef = (0,react.useRef)();
    var nextRef = (0,react.useRef)();
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var ref1 = (0,useBusinessCasesVideosQuery/* useBusinessCasesVideosQuery */.i)(10), data = ref1.data, isLoading = ref1.isLoading;
    var isRTL = (0,useIsRTL/* useIsRTL */.S)();
    (0,react.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var preparedVideos = (0,react.useMemo)(function() {
        var videos = data === null || data === void 0 ? void 0 : data.map(function(video) {
            var speaker = translateItem(video.speakers[0].people_id);
            return {
                speaker: speaker,
                link: route/* route.video */.BC.video(video).page()
            };
        });
        return videos || [];
    }, [
        data,
        translateItem
    ]);
    var hasContent = isLoading || preparedVideos.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* GenericSectionHeader */.O, {
                section: section
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperArea, {
                children: hasContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwiperContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
                            theme: theme/* redTheme */.MN,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSwiper, {
                                threshold: 15,
                                onSwiper: setSwiper,
                                slidesPerView: "auto",
                                watchSlidesProgress: true,
                                navigation: {
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current
                                },
                                wrapperTag: "ul",
                                children: isLoading ? range_default()(5).map(function(num) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                        tag: "li",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                            fill: true
                                        })
                                    }, num);
                                }) : preparedVideos.map(function(param) {
                                    var link = param.link, speaker = param.speaker;
                                    var ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                        tag: "li",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                                            href: link,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallerShowcase, {
                                                image: (ref = speaker.portrait) === null || ref === void 0 ? void 0 : ref.id,
                                                title: speaker.name,
                                                subtitle: [
                                                    speaker.degree,
                                                    speaker.title
                                                ].filter(function(el) {
                                                    return el;
                                                }).join(", ")
                                            })
                                        })
                                    }, link);
                                })
                            }, key)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components/* Theme */.Q, {
                            theme: theme/* darkTheme */.$_,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavigationButton, {
                                    kind: "circled",
                                    ref: prevRef,
                                    icon: ChevronLeft/* ChevronLeft */.s,
                                    $direction: "left"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavigationButton, {
                                    kind: "circled",
                                    ref: nextRef,
                                    icon: ChevronRight/* ChevronRight */._,
                                    $direction: "right"
                                })
                            ]
                        })
                    ]
                })
            }, String(isRTL) + key)
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/common/DirectusImage.tsx
var DirectusImage = __webpack_require__(52520);
// EXTERNAL MODULE: ./src/styles/common.ts
var styles_common = __webpack_require__(12258);
// EXTERNAL MODULE: ./vendor/mods/media-breakpoints-fresnel/components/Media.tsx
var Media = __webpack_require__(50696);
// EXTERNAL MODULE: ./src/modules/protocols/hooks/useProtocolsQuery.ts + 1 modules
var useProtocolsQuery = __webpack_require__(79169);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/containers/ProtocolsContainer.tsx

function ProtocolsContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 252px;\n  height: 313px;\n\n  ",
        " {\n    width: 591px;\n    height: 313px;\n  }\n"
    ]);
    ProtocolsContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProtocolsContainer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: var(--results-left-margin);\n  padding-right: calc(var(--constraint-container-right-margin) - 20px);\n  margin-bottom: 42px;\n\n  ",
        " {\n    padding-right: var(--results-left-margin);\n    padding-left: calc(var(--constraint-container-right-margin) - 20px);\n  }\n\n  ",
        " {\n    margin-bottom: 40px;\n  }\n\n  .swiper-slide {\n    position: relative;\n    margin-right: 19px;\n    ",
        ";\n\n    ",
        " {\n      margin-right: 0;\n      margin-left: 19px;\n    }\n  }\n"
    ]);
    ProtocolsContainer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProtocolsContainer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  margin: 0 calc(-1 * var(--results-right-margin)) 0\n    calc(-1 * var(--results-left-margin));\n\n  ",
        " {\n    margin: 0 calc(-1 * var(--results-left-margin)) 0\n      calc(-1 * var(--results-right-margin));\n  }\n"
    ]);
    ProtocolsContainer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProtocolsContainer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        " {\n    opacity: 0;\n  }\n  &:hover > ",
        " {\n    opacity: 1;\n  }\n"
    ]);
    ProtocolsContainer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProtocolsContainer_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  direction: ltr;\n  background: #f2f2f2;\n  display: grid;\n  grid-template-areas: 'logo' 'tags' 'cta';\n  grid-gap: 30px;\n  grid-template-rows: 38px auto auto;\n  grid-template-columns: 1fr;\n  padding: 36px 45px 46px 30px;\n\n  & > * {\n    z-index: 2;\n  }\n\n  ",
        " {\n    padding: 0px;\n    grid-template-areas:\n      'space .'\n      'space logo'\n      'space tags'\n      'space cta'\n      'space .';\n    grid-template-rows: 1fr 47px auto auto 1fr;\n    grid-template-columns: 257px 1fr;\n    grid-gap: 28px 40px;\n    padding-right: 40px;\n  }\n"
    ]);
    ProtocolsContainer_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProtocolsContainer_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  z-index: 1;\n"
    ]);
    ProtocolsContainer_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  grid-area: logo;\n\n  img {\n    object-fit: contain;\n    object-position: left center;\n    max-width: max-content;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-right: 1em;\n  font-size: 12px;\n  line-height: 18px;\n  display: inline-block;\n\n  ",
        " {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n  }\n  ",
        " {\n    direction: rtl;\n    margin-right: 0;\n    margin-left: 1em;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: tags;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: flex-start;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    grid-area: cta;\n    height: 40px;\n    min-width: unset;\n    margin-top: auto;\n\n    ",
        " {\n      width: 207px;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    top: 50%;\n    transform: translateY(-50%);\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






















var swiperElement = (0,styled_components_browser_esm.css)(ProtocolsContainer_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProtocolsContainer_VideoSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "ProtocolsContainer__VideoSwiper",
    componentId: "sc-57101395-0"
})(ProtocolsContainer_templateObject1(), theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, swiperElement, theme/* dirRTL */.gX);
var ProtocolsContainer_SwiperArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolsContainer__SwiperArea",
    componentId: "sc-57101395-1"
})(ProtocolsContainer_templateObject2(), theme/* dirRTL */.gX);
var ProtocolsContainer_SwiperContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolsContainer__SwiperContent",
    componentId: "sc-57101395-2"
})(ProtocolsContainer_templateObject3(), common/* NavigationButton */.W, common/* NavigationButton */.W);
var Protocol = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolsContainer__Protocol",
    componentId: "sc-57101395-3"
})(ProtocolsContainer_templateObject4(), swiperElement, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProtocolPreview = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolsContainer__ProtocolPreview",
    componentId: "sc-57101395-4"
})(ProtocolsContainer_templateObject5(), styles_common/* layer */.EY);
var ProtocolLogo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolsContainer__ProtocolLogo",
    componentId: "sc-57101395-5"
})(_templateObject6());
var Tag = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ProtocolsContainer__Tag",
    componentId: "sc-57101395-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX);
var ProtocolTags = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProtocolsContainer__ProtocolTags",
    componentId: "sc-57101395-7"
})(_templateObject8());
var ProtocolCTA = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ProtocolsContainer__ProtocolCTA",
    componentId: "sc-57101395-8"
})(_templateObject9(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ProtocolsContainer_StyledNavigationButton = (0,styled_components_browser_esm["default"])(common/* NavigationButton */.W).withConfig({
    displayName: "ProtocolsContainer__StyledNavigationButton",
    componentId: "sc-57101395-9"
})(_templateObject10());
var ProtocolsContainer = function(param) {
    var section = param.section;
    var _ = (0,lib.useTranslate)()._;
    var key = (0,useFastRefreshFixer/* useFastRefreshFixer */.P)();
    var prevRef = (0,react.useRef)();
    var nextRef = (0,react.useRef)();
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var ref1 = (0,useProtocolsQuery/* useProtocolsQuery */.t)(), protocols = ref1.data, isLoading = ref1.isLoading;
    var isRTL = (0,useIsRTL/* useIsRTL */.S)();
    (0,react.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var hasContent = isLoading || protocols != null && protocols.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* GenericSectionHeader */.O, {
                section: section
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolsContainer_SwiperArea, {
                children: hasContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProtocolsContainer_SwiperContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolsContainer_VideoSwiper, {
                            threshold: 15,
                            onSwiper: setSwiper,
                            slidesPerView: "auto",
                            watchSlidesProgress: true,
                            navigation: {
                                prevEl: prevRef.current,
                                nextEl: nextRef.current
                            },
                            wrapperTag: "ul",
                            children: isLoading ? range_default()(5).map(function(num) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                    tag: "li",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {})
                                }, num);
                            }) : protocols === null || protocols === void 0 ? void 0 : protocols.map(translateItem).map(function(protocol) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                    tag: "li",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Protocol, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProtocolPreview, {
                                                children: [
                                                    protocol.preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                                                        greaterThanOrEqual: "desktop",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                                            sizes: "(min-width: 1000px) 50vw, 90vw",
                                                            quality: "90",
                                                            src: protocol.preview.id,
                                                            layout: "fill",
                                                            objectFit: "cover"
                                                        })
                                                    }),
                                                    protocol.previewMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                                                        lessThan: "desktop",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                                            sizes: "(min-width: 1000px) 50vw, 90vw",
                                                            quality: "90",
                                                            src: protocol.previewMobile.id,
                                                            layout: "fill",
                                                            objectFit: "cover"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components/* Theme */.Q, {
                                                theme: theme/* redTheme */.MN,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolLogo, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                                            src: protocol.logo.id,
                                                            layout: "fill"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolTags, {
                                                        children: protocol.tags.map(function(tag) {
                                                            return tag.tags_id;
                                                        }).map(translateItem).map(function(tag) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                                                children: tag.name
                                                            }, tag.id);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                                                        href: "/protocols/".concat(protocol.slug),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCTA, {
                                                            forwardedAs: "a",
                                                            children: _("Go to protocol")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, protocol.id);
                            })
                        }, key),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components/* Theme */.Q, {
                            theme: theme/* darkTheme */.$_,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolsContainer_StyledNavigationButton, {
                                    kind: "circled",
                                    ref: prevRef,
                                    icon: ChevronLeft/* ChevronLeft */.s,
                                    $direction: "left"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolsContainer_StyledNavigationButton, {
                                    kind: "circled",
                                    ref: nextRef,
                                    icon: ChevronRight/* ChevronRight */._,
                                    $direction: "right"
                                })
                            ]
                        })
                    ]
                })
            }, String(isRTL) + key)
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/materials/components/Thumbnail/index.tsx + 6 modules
var Thumbnail = __webpack_require__(87847);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./src/modules/materials/providers/ShowcaseContext.tsx
var ShowcaseContext = __webpack_require__(54095);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/renderers/GridResultSectionRender.tsx



function GridResultSectionRender_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  align-content: flex-start;\n  align-items: flex-start;\n  justify-items: flex-start;\n  grid-gap: 20px;\n  grid-template-columns: 1fr;\n\n  ",
        " {\n    grid-template-columns: repeat(3, 264px);\n    margin-right: calc(-1 * var(--results-right-margin));\n\n    ",
        " {\n      margin-right: 0;\n      margin-left: calc(-1 * var(--results-right-margin));\n    }\n  }\n"
    ]);
    GridResultSectionRender_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Grid = (0,styled_components_browser_esm["default"])(motion/* motion.ul */.E.ul).withConfig({
    displayName: "GridResultSectionRender__Grid",
    componentId: "sc-d43fdbc4-0"
})(GridResultSectionRender_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX);
var GridResultSectionRender = /*#__PURE__*/ (0,react.memo)(function GridResultSectionRender(param) {
    var section = param.section, items = param.items;
    var thumbnailOptions = (0,react.useContext)(ShowcaseContext/* ShowcaseContext */.r).thumbnailOptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                fade: true
            })), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* GenericSectionHeader */.O, {
                    section: section
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                fade: true,
                stagger: 0.02
            })), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    presenceAffectsLayout: true,
                    children: items === null || items === void 0 ? void 0 : items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* Thumbnail */.$, (0,_object_spread/* default */.Z)({
                            item: item,
                            uniqueId: item.id + section.name,
                            as: motion/* motion.li */.E.li,
                            layout: "position"
                        }, thumbnailOptions, (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            from: "topMore",
                            to: "bottomLess",
                            speed: "faster",
                            enterDelay: 0.2,
                            forStagger: true
                        })), item.id);
                    })
                })
            }))
        ]
    });
});

;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/containers/SearchResultsContainer.tsx



var SearchResultsContainer = /*#__PURE__*/ (0,react.memo)(function SearchResultsContainer(param) {
    var heading = param.heading, filters = param.filters, results = param.results;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridResultSectionRender, {
        section: {
            name: heading !== null && heading !== void 0 ? heading : filters.q ? String(filters.q) : "Results",
            count: Number(results === null || results === void 0 ? void 0 : results.count) < 0 ? 0 : results === null || results === void 0 ? void 0 : results.count
        },
        items: results === null || results === void 0 ? void 0 : results.items
    });
});

// EXTERNAL MODULE: ./src/utils/WithSilentErrorBoundary.tsx
var WithSilentErrorBoundary = __webpack_require__(45402);
;// CONCATENATED MODULE: ./src/hooks/useKeepData.ts

var useKeepData = function(data, keepPrevious) {
    var dataStash = (0,react.useRef)(data);
    if (!keepPrevious) {
        dataStash.current = data;
    }
    return dataStash.current;
};

// EXTERNAL MODULE: ./node_modules/react-use/esm/useUpdateEffect.js
var useUpdateEffect = __webpack_require__(48286);
// EXTERNAL MODULE: ./src/components/common/Loader.tsx
var Loader = __webpack_require__(15572);
// EXTERNAL MODULE: ./src/modules/materials/models/showcase.ts
var showcase = __webpack_require__(80614);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./src/utils/eventHandlerHelpers.ts
var eventHandlerHelpers = __webpack_require__(89755);
// EXTERNAL MODULE: ./node_modules/rambda/dist/rambda.esm.js
var rambda_esm = __webpack_require__(49713);
// EXTERNAL MODULE: ./node_modules/react-hook-inview/dist/esm/index.js + 2 modules
var esm = __webpack_require__(69671);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(10763);
// EXTERNAL MODULE: ./src/components/common/ScrollToViewport.tsx
var ScrollToViewport = __webpack_require__(66660);
// EXTERNAL MODULE: ./src/hooks/useCallbackEffects.ts + 1 modules
var useCallbackEffects = __webpack_require__(48363);
// EXTERNAL MODULE: ./src/components/player/index.tsx + 30 modules
var player = __webpack_require__(44732);
// EXTERNAL MODULE: ./src/modules/materials/providers/TaxonomyContext.tsx
var TaxonomyContext = __webpack_require__(74729);
// EXTERNAL MODULE: ./src/modules/videos/utils/videoQueryFactory.ts
var videoQueryFactory = __webpack_require__(12356);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/renderers/VideoHeroListSectionRender.tsx




function VideoHeroListSectionRender_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: 353px;\n  display: grid;\n  grid-template-areas: 'number player list';\n  grid-template-columns: calc(var(--results-left-margin) - 20px) 621px 1fr;\n  grid-column-gap: 20px;\n  overflow: hidden;\n  margin: 0 calc(-1 * var(--results-right-margin) + 20px) 40px\n    calc(-1 * var(--results-left-margin));\n\n  ",
        " {\n    margin: 0 calc(-1 * var(--results-left-margin)) 40px\n      calc(-1 * var(--results-right-margin) + 20px);\n  }\n\n  ",
        " {\n    min-height: unset;\n    grid-template-areas: 'player' 'list';\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    margin: 0 calc(-1 * var(--results-right-margin)) 42px\n      calc(-1 * var(--results-left-margin));\n    background: linear-gradient(\n      227.25deg,\n      rgba(196, 196, 196, 0) 48.08%,\n      rgba(235, 235, 235, 0.47) 100%\n    );\n\n    ",
        " {\n      margin: 0 calc(-1 * var(--results-left-margin)) 42px\n        calc(-1 * var(--results-right-margin));\n    }\n  }\n"
    ]);
    VideoHeroListSectionRender_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: number;\n  margin-top: auto;\n  position: relative;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    VideoHeroListSectionRender_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 242.222px;\n  color: ",
        ";\n  vertical-align: baseline;\n  position: relative;\n  top: 55px;\n  left: 28px;\n  ",
        " {\n    left: auto;\n    right: 28px;\n  }\n"
    ]);
    VideoHeroListSectionRender_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: player;\n  position: relative;\n  overflow: hidden;\n  background: black;\n  z-index: 2;\n\n  ",
        ";\n"
    ]);
    VideoHeroListSectionRender_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: list;\n  display: grid;\n  grid-row-gap: 33px;\n  align-items: flex-end;\n  align-content: flex-start;\n  margin: 19px 0;\n\n  ",
        " {\n    min-height: 68px;\n    margin: 0;\n    padding: 18px 0;\n\n    display: flex;\n    flex-direction: row;\n    overflow: auto;\n    gap: 0px;\n  }\n"
    ]);
    VideoHeroListSectionRender_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n  "
    ]);
    VideoHeroListSectionRender_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 200;\n  font-size: 40px;\n  line-height: 36px;\n  color: ",
        ";\n  flex: 0 1 auto;\n\n  ",
        ";\n"
    ]);
    VideoHeroListSectionRender_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 1;\n  "
    ]);
    VideoHeroListSectionRender_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 67px;\n  height: calc(67px * 9 / 16);\n  position: relative;\n  opacity: 0.3;\n\n  img {\n    object-fit: cover;\n  }\n\n  ",
        ";\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    VideoHeroListSectionRender_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: left;\n  display: grid;\n  grid-template-areas: 'number image name';\n  grid-template-columns: 24px 67px 1fr;\n\n  grid-auto-flow: row;\n  grid-column-gap: 12px;\n  align-items: flex-end;\n\n  ",
        " {\n    flex: 0 0 auto;\n    display: flex;\n    min-width: auto;\n    flex-direction: row;\n\n    padding: 0 calc(var(--results-right-margin)) 0\n      calc(var(--results-left-margin));\n  }\n"
    ]);
    VideoHeroListSectionRender_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function VideoHeroListSectionRender_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    color: ",
        ";\n  "
    ]);
    VideoHeroListSectionRender_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 110%;\n  color: ",
        ";\n\n  ",
        ";\n  flex: 0 1 auto;\n\n  ",
        " {\n    margin-bottom: 0.15em;\n    max-width: 162px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


























var Area = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__Area",
    componentId: "sc-e58d0f53-0"
})(VideoHeroListSectionRender_templateObject(), theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
var SelectedVideoNumberContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "VideoHeroListSectionRender__SelectedVideoNumberContainer",
    componentId: "sc-e58d0f53-1"
})(VideoHeroListSectionRender_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var BigNumber = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__BigNumber",
    componentId: "sc-e58d0f53-2"
})(VideoHeroListSectionRender_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.gray5;
}, theme/* dirRTL */.gX);
var ItemArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__ItemArea",
    componentId: "sc-e58d0f53-3"
})(VideoHeroListSectionRender_templateObject3(), (0,styles_common.ar)(16 / 9));
var List = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__List",
    componentId: "sc-e58d0f53-4"
})(VideoHeroListSectionRender_templateObject4(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Index = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__Index",
    componentId: "sc-e58d0f53-5"
})(VideoHeroListSectionRender_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(VideoHeroListSectionRender_templateObject5())));
var VideoHeroListSectionRender_Thumbnail = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__Thumbnail",
    componentId: "sc-e58d0f53-6"
})(VideoHeroListSectionRender_templateObject8(), (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(VideoHeroListSectionRender_templateObject7())), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Select = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "VideoHeroListSectionRender__Select",
    componentId: "sc-e58d0f53-7"
})(VideoHeroListSectionRender_templateObject9(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Name = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__Name",
    componentId: "sc-e58d0f53-8"
})(_templateObject11(), (0,styles_common/* lineClamp */.Sf)(2), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
}, (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(VideoHeroListSectionRender_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
})), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Layer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoHeroListSectionRender__Layer",
    componentId: "sc-e58d0f53-9"
})(_templateObject12(), styles_common/* layer */.EY);
var VideoHeroListSectionRender = function(param) {
    var section = param.section, items = param.items, isLoading = param.isLoading;
    var ref = (0,react.useState)(0), selectedVideo = ref[0], setSelectedVideo = ref[1];
    var ref1 = (0,react.useState)(false), interacted = ref1[0], setInteracted = ref1[1];
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var selectVideo = (0,useCallbackEffects/* useCallbackEffects */._)((0,eventHandlerHelpers/* valueFromTargetDataset */.d)("index")((0,rambda_esm.pipe)(function(v) {
        return v ? parseInt(v) : 0;
    }, setSelectedVideo)), (0,rambda_esm.pipe)((0,rambda_esm.always)(true), setInteracted));
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,esm/* useInView */.Y)(), 2), ref3 = ref2[0], inView = ref2[1];
    var selectedVideoData = items === null || items === void 0 ? void 0 : items[selectedVideo];
    var fullVideoData = (0,es.useQuery)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,videoQueryFactory/* videoQueryByIdFactory */.f)((0,useAPIs/* useAPIs */.V)(), selectedVideoData === null || selectedVideoData === void 0 ? void 0 : selectedVideoData.id)), {
        enabled: inView && !!(selectedVideoData === null || selectedVideoData === void 0 ? void 0 : selectedVideoData.id)
    }));
    var hasVideos = isLoading || items != null && items.length > 0;
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    var videoTransition = isDesktop ? (0,transitions/* makeTransition */.Vr)({
        from: "rightFull",
        to: "leftFull",
        fade: "exit",
        speed: "slow",
        easing: "default",
        sortZIndex: true
    }) : (0,transitions/* makeTransition */.Vr)({
        fade: true,
        speed: "slow",
        easing: "default",
        sortZIndex: true
    });
    var _data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TaxonomyContext/* TaxonomyContext.Provider */.u.Provider, {
        value: section.taxonomy,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* GenericSectionHeader */.O, {
                section: section
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Area, {
                children: hasVideos && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            exitBeforeEnter: true,
                            initial: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedVideoNumberContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                                from: "rightFull",
                                to: "leftFull",
                                fade: true,
                                easing: "default"
                            })), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BigNumber, {
                                    children: selectedVideo + 1
                                })
                            }), selectedVideo)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemArea, {
                            ref: ref3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                initial: false,
                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                    fill: true
                                }, selectedVideoData === null || selectedVideoData === void 0 ? void 0 : selectedVideoData.id) : selectedVideoData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, videoTransition), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* NeauviaPlayerLayer */.jT, {
                                        video: (_data = fullVideoData.data) !== null && _data !== void 0 ? _data : selectedVideoData,
                                        autoPlay: interacted
                                    })
                                }), selectedVideoData.id)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                            children: isLoading && isDesktop ? range_default()(5).map(function(num) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                    height: 36
                                }, num);
                            }) : items === null || items === void 0 ? void 0 : items.map(translateItem).map(function(video, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToViewport/* ScrollToViewport */.v, {
                                    active: selectedVideo === index,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                        "data-index": index,
                                        onClick: selectVideo,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Index, {
                                                $active: selectedVideo === index,
                                                children: [
                                                    index + 1,
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoHeroListSectionRender_Thumbnail, {
                                                $active: selectedVideo === index,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                                    src: video.thumbnail.id,
                                                    layout: "fill"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                                $active: selectedVideo === index,
                                                children: video.name
                                            })
                                        ]
                                    })
                                }, video.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/containers/VideoHeroListQueryContainer.tsx





var VideoHeroListQueryContainer = function(param) {
    var section = param.section, tmp = param.render, Render = tmp === void 0 ? VideoHeroListSectionRender : tmp;
    var videos = (0,useVideosListQuery/* useVideosListQuery */.L)(videos_basic_query/* videosBasicGqlQuery */.g, section.variables);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Render, {
        section: section,
        items: videos.data,
        isLoading: videos.isLoading
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/materials/graphql/materials-basic.fragment.ts

function materials_basic_fragment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment materialsBasic on materials {\n    id\n    slug\n    type\n    date_created\n    thumbnail {\n      id\n    }\n    subjects {\n      subjects_id {\n        slug\n      }\n    }\n    tags {\n      tags_id {\n        id\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    translations {\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n  }\n"
    ]);
    materials_basic_fragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var materialsBasicFragment = (0,gql_query/* gql */.Ps)(materials_basic_fragment_templateObject());

;// CONCATENATED MODULE: ./src/modules/materials/graphql/materials-basic.query.ts

function materials_basic_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query MaterialsBasicQuery(\n    $filters: materials_filter\n    $sort: [String]\n    $limit: Int\n  ) {\n    materials(filter: $filters, sort: $sort, limit: $limit) {\n      ...materialsBasic\n    }\n  }\n"
    ]);
    materials_basic_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var materialsBasicGqlQuery = (0,gql_query/* gql */.Ps)(materials_basic_query_templateObject(), materialsBasicFragment);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./src/services/search.ts
var search = __webpack_require__(55889);
;// CONCATENATED MODULE: ./src/modules/materials/hooks/useNeauviaItemsListQuery.ts













var queriesMap = {
    videos: videos_basic_query/* videosBasicGqlQuery */.g,
    materials: materialsBasicGqlQuery
};
var fetchNeauviaItems = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, variables) {
        var ref, itemsToQuery, ref1, ref2, ref3, itemToQuery, directus, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    itemsToQuery = (ref = variables === null || variables === void 0 ? void 0 : variables.itemsToQuery) !== null && ref !== void 0 ? ref : [
                        "materials",
                        "videos"
                    ];
                    /**
   * Check if passed filters include filter parameter specific for any item kind.
   * If so, don't fetch other items - e.g "duration" filter was passed, then don't fetch any materials, just videos.
   */ if (variables === null || variables === void 0 ? void 0 : variables.filters) {
                        ;
                        ;
                        itemToQuery = itemsToQuery.find(function(kind) {
                            return Object.keys((ref3 = variables === null || variables === void 0 ? void 0 : variables.filters) !== null && ref3 !== void 0 ? ref3 : {}).some(function(key) {
                                return Object.keys((0,rambda_esm.omit)(Object.keys(search/* commonFiltersToQueryMap */.qN), (0,rambda_esm.omit)(search/* hiddenFilters */.x_, search/* searchFiltersToQueryMap */.IA[kind]))).includes(key);
                            });
                        });
                        if (itemToQuery) {
                            itemsToQuery = [
                                itemToQuery
                            ];
                        }
                        // Workaround to the comment above :(
                        if ("type" in variables.filters && ((ref1 = variables.filters.type) === null || ref1 === void 0 ? void 0 : (ref2 = ref1._in) === null || ref2 === void 0 ? void 0 : ref2.includes("videos"))) {
                            itemsToQuery.push("videos");
                        }
                    }
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        4,
                        itemsToQuery.reduce(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(prev, curr) {
                                var options, items;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
                                                filters: (0,rambda_esm.pick)([
                                                    "_or"
                                                ].concat((0,_to_consumable_array/* default */.Z)((0,search/* getItemSpecificFilterKeys */.ho)(curr))), variables === null || variables === void 0 ? void 0 : variables.filters)
                                            });
                                            return [
                                                4,
                                                directus.query(queriesMap[curr], options).then(function(d) {
                                                    return d[curr];
                                                })
                                            ];
                                        case 1:
                                            items = _state.sent();
                                            return [
                                                4,
                                                prev
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                _to_consumable_array/* default.apply */.Z.apply(void 0, [
                                                    _state.sent()
                                                ]).concat((0,_to_consumable_array/* default */.Z)(items))
                                            ];
                                    }
                                });
                            });
                            return function(prev, curr) {
                                return _ref.apply(this, arguments);
                            };
                        }(), Promise.resolve([]))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.sort(function(a, b) {
                            return (0,parseISO/* default */.Z)(b.date_created).getTime() - (0,parseISO/* default */.Z)(a.date_created).getTime();
                        }).slice(0, variables === null || variables === void 0 ? void 0 : variables.limit)
                    ];
            }
        });
    });
    return function fetchNeauviaItems(apis, variables) {
        return _ref.apply(this, arguments);
    };
}();
var useNeauviaItemsListQuery = function(variables, options) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.MaterialsList */.S.MaterialsList).concat([
        variables
    ]), function() {
        return fetchNeauviaItems(apis, variables);
    }, options);
};

;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/containers/SliderQueryContainer.tsx






var SliderQueryContainer = function(param) {
    var section = param.section, tmp = param.render, Render = tmp === void 0 ? SliderSectionRender/* SliderSectionRender */.t : tmp;
    var ref;
    var itemsToQuery = (0,react.useContext)(ShowcaseContext/* ShowcaseContext */.r).itemsToQuery;
    var items = useNeauviaItemsListQuery((0,_object_spread/* default */.Z)({
        itemsToQuery: itemsToQuery
    }, section.variables));
    if (!items.isLoading && ((ref = items.data) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Render, {
        section: section,
        items: items.data,
        isLoading: items.isLoading
    });
};

// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(34156);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
// EXTERNAL MODULE: ./src/utils/queryCommonOptions.tsx
var queryCommonOptions = __webpack_require__(57750);
;// CONCATENATED MODULE: ./src/modules/materials/hooks/useSearchItemsByFiltersQuery.ts













var checkActiveFilters = memoizee_default()(function(filters) {
    return Object.values((0,rambda_esm.omit)(search/* hiddenFilters */.x_, filters)).filter(function(v) {
        return !!v;
    }).length > 0;
}, {
    max: 1
});
var searchItemsByFilters = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, filters, variables) {
        var ref, itemsToQuery, preparedFilters, items, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!checkActiveFilters(filters)) {
                        return [
                            2,
                            {
                                count: -1,
                                items: []
                            }
                        ];
                    }
                    itemsToQuery = (ref = variables === null || variables === void 0 ? void 0 : variables.itemsToQuery) !== null && ref !== void 0 ? ref : [
                        "materials",
                        "videos"
                    ];
                    preparedFilters = (0,search/* mapSearchFiltersToQuery */.z0)(filters);
                    return [
                        4,
                        fetchNeauviaItems(apis, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variables), {
                            itemsToQuery: itemsToQuery,
                            filters: preparedFilters
                        }))
                    ];
                case 1:
                    items = _state.sent();
                    return [
                        2,
                        {
                            count: (ref1 = items === null || items === void 0 ? void 0 : items.length) !== null && ref1 !== void 0 ? ref1 : 0,
                            items: items
                        }
                    ];
            }
        });
    });
    return function searchItemsByFilters(apis, filters, variables) {
        return _ref.apply(this, arguments);
    };
}();
var searchItemsByFiltersQuery = function(apis, filters, variables) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        queryKey: (0,_to_consumable_array/* default */.Z)(query/* QueryKey.SearchResults */.S.SearchResults).concat([
            filters,
            variables
        ])
    }, queryCommonOptions/* queryCommonOptions.commonHandlers */.e.commonHandlers, queryCommonOptions/* queryCommonOptions.longStale */.e.longStale), {
        queryFn: function() {
            return searchItemsByFilters(apis, filters, variables);
        }
    });
};
var useSearchItemsByFiltersQuery = function(filters, variables) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(searchItemsByFiltersQuery(apis, filters, variables));
};

// EXTERNAL MODULE: ./node_modules/fast-equals/dist/fast-equals.js
var fast_equals = __webpack_require__(58367);
// EXTERNAL MODULE: ./src/hooks/useDelayedValue.ts
var useDelayedValue = __webpack_require__(12230);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/ShowcaseGallery.tsx



function ShowcaseGallery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 20px;\n  --results-right-margin: var(--constraint-container-left-margin);\n  --results-left-margin: var(--constraint-container-right-margin);\n  min-height: calc(var(--vh) * 33);\n\n  ",
        " {\n    padding: 42px 120px;\n    --results-right-margin: calc(\n      120px + var(--constraint-container-right-margin)\n    );\n    --results-left-margin: 120px;\n    min-height: 0;\n  }\n"
    ]);
    ShowcaseGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShowcaseGallery_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.3;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  margin-top: -16px;\n  margin-bottom: 26px;\n  ",
        " {\n    margin-bottom: 34px;\n  }\n"
    ]);
    ShowcaseGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}























var ResultsContainer = styled_components_browser_esm["default"].main.withConfig({
    displayName: "ShowcaseGallery__ResultsContainer",
    componentId: "sc-5cc2c9f5-0"
})(ShowcaseGallery_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Title = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "ShowcaseGallery__Title",
    componentId: "sc-5cc2c9f5-1"
})(ShowcaseGallery_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Section = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(/*#__PURE__*/ (0,react.memo)(function Section(param) {
    var section = param.section;
    switch(section.type){
        case showcase/* ShowcaseSection.List */.Y.List:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderQueryContainer, {
                section: section
            });
        case showcase/* ShowcaseSection.Favorites */.Y.Favorites:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFavouritesContainer, {
                section: section
            });
        case showcase/* ShowcaseSection.BusinessCases */.Y.BusinessCases:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessCasesContainer, {
                section: section
            });
        case showcase/* ShowcaseSection.ProtocolTreatment */.Y.ProtocolTreatment:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolsContainer, {
                section: section
            });
        case showcase/* ShowcaseSection.HeroList */.Y.HeroList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoHeroListQueryContainer, {
                section: section
            });
        default:
            return null;
    }
}));
var ShowcaseGallery = function(param) {
    var filters = param.filters, sectionsQuery = param.sectionsQuery;
    var ref;
    var hasActiveFilters = checkActiveFilters(filters);
    var sectionsQueryResult = sectionsQuery();
    var favoriteVideos = (0,useFavouriteVideosQuery/* useFavoriteVideosQuery */.vS)();
    var ref1 = (0,react.useContext)(ShowcaseContext/* ShowcaseContext */.r), title = ref1.title, itemsToQuery = ref1.itemsToQuery, defaultFilters = ref1.defaultFilters;
    var customHeading = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = (ref = sectionsQueryResult.data) === null || ref === void 0 ? void 0 : ref.find(function(section) {
            return (0,fast_equals.shallowEqual)(section.searchQuery, filters);
        })) === null || ref1 === void 0 ? void 0 : ref1.name;
    }, [
        sectionsQueryResult.data,
        filters
    ]);
    // TODO: find a better way to overwrite search filters
    var ref2 = (0,react.useMemo)(function() {
        if (filters.favourites && favoriteVideos.data) {
            return [
                favoriteVideos.data.length ? {
                    status: [
                        "published"
                    ],
                    id: favoriteVideos.data
                } : {},
                undefined, 
            ];
        }
        if (filters.recent) {
            return [
                (0,_object_spread/* default */.Z)({}, filters, defaultFilters),
                {
                    limit: 20,
                    sort: [
                        "-date_created"
                    ]
                }, 
            ];
        }
        return [
            (0,_object_spread/* default */.Z)({}, filters, defaultFilters),
            undefined
        ];
    }, [
        filters,
        defaultFilters,
        favoriteVideos.data
    ]), queryFilters = ref2[0], variables = ref2[1];
    var searchQueryResults = useSearchItemsByFiltersQuery(queryFilters, (0,_object_spread/* default */.Z)({
        itemsToQuery: itemsToQuery
    }, variables));
    var isFetchingData = sectionsQueryResult.isFetching || searchQueryResults.isFetching;
    var sections = useKeepData(sectionsQueryResult, isFetchingData);
    var showSections = useKeepData(!hasActiveFilters && (sections === null || sections === void 0 ? void 0 : sections.data) != null, isFetchingData);
    var results = useKeepData(searchQueryResults.data, isFetchingData);
    (0,useUpdateEffect/* default */.Z)(function() {
        window.scroll({
            top: 0,
            behavior: "smooth"
        });
    }, [
        isFetchingData
    ]);
    var isFetchingDataDelayed = (0,useDelayedValue/* useDelayedValue */.t)(isFetchingData, 600);
    var delayedFilters = useKeepData(filters, isFetchingData);
    var delayedHeading = useKeepData(customHeading, isFetchingData);
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultsContainer, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                exitBeforeEnter: true,
                presenceAffectsLayout: true,
                children: isFetchingData && isFetchingDataDelayed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* HeroLoaderFillLayer */.UL, {}) : results && ~results.count || customHeading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer, {
                    heading: delayedHeading ? _(delayedHeading) : undefined,
                    filters: delayedFilters,
                    results: results
                }, "search") : showSections ? /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                    stagger: 0.05
                })), {
                    children: sections === null || sections === void 0 ? void 0 : (ref = sections.data) === null || ref === void 0 ? void 0 : ref.map(function(section) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                            fade: true,
                            forStagger: true
                        })), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                section: section
                            })
                        }), section.name);
                    })
                }), "default") : null
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/hooks/useQueryParams.ts



var useQueryParams = function() {
    var router = (0,next_router.useRouter)();
    var setParams = (0,react.useCallback)(function(params) {
        if ((0,query_string.stringify)(params) === (0,query_string.stringify)(router.query)) {
            return true;
        }
        return router.replace({
            query: params,
            pathname: router.pathname
        }, undefined, {
            shallow: true
        });
    }, [
        router.pathname,
        router.query
    ]);
    return [
        router.query,
        setParams
    ];
};

// EXTERNAL MODULE: ./src/utils/reactQuery.tsx
var reactQuery = __webpack_require__(4766);
// EXTERNAL MODULE: ./src/components/filters/types.ts
var types = __webpack_require__(26026);
// EXTERNAL MODULE: ./src/components/icons/Close.tsx
var Close = __webpack_require__(34039);
;// CONCATENATED MODULE: ./src/components/filters/FilterMultiselect.tsx


function FilterMultiselect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  justify-items: flex-start;\n  grid-auto-flow: row;\n  grid-gap: 8px;\n"
    ]);
    FilterMultiselect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterMultiselect_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(-45deg) scale(0.5);\n  }\n  to {\n    transform: rotate(0deg) scale(1.0);\n  }\n"
    ]);
    FilterMultiselect_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterMultiselect_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg) scale(0.5);\n  }\n  to {\n    transform: rotate(45deg) scale(1.0);\n  }\n"
    ]);
    FilterMultiselect_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FilterMultiselect_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              opacity: 1;\n              animation: ",
        "\n                ",
        "s\n                ",
        " forwards;\n            "
    ]);
    FilterMultiselect_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FilterMultiselect_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              opacity: 0;\n              animation: ",
        "\n                ",
        "s\n                ",
        " forwards;\n            "
    ]);
    FilterMultiselect_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FilterMultiselect_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    display: block;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n    text-transform: ",
        ";\n\n    .btn__icon {\n      transition: opacity ",
        "s\n        ",
        ";\n      ",
        "\n    }\n  }\n"
    ]);
    FilterMultiselect_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var FilterMultiselectOptionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterMultiselect__FilterMultiselectOptionsContainer",
    componentId: "sc-b3440b33-0"
})(FilterMultiselect_templateObject());
var checkAppear = (0,styled_components_browser_esm.keyframes)(FilterMultiselect_templateObject1());
var checkDisappear = (0,styled_components_browser_esm.keyframes)(FilterMultiselect_templateObject2());
var FilterButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "FilterMultiselect__FilterButton",
    componentId: "sc-b3440b33-1"
})(FilterMultiselect_templateObject5(), function(param) {
    var $capitalize = param.$capitalize;
    return $capitalize ? "capitalize" : "unset";
}, (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.decelerated;
}), function(param) {
    var $checked = param.$checked;
    return $checked ? (0,styled_components_browser_esm.css)(FilterMultiselect_templateObject3(), checkAppear, (0,theme/* fromTheme */.HW)(function(t) {
        return t.animation.duration;
    }), (0,theme/* fromTheme */.HW)(function(t) {
        return t.animation.easing.decelerated;
    })) : (0,styled_components_browser_esm.css)(FilterMultiselect_templateObject4(), checkDisappear, (0,theme/* fromTheme */.HW)(function(t) {
        return t.animation.duration;
    }), (0,theme/* fromTheme */.HW)(function(t) {
        return t.animation.easing.decelerated;
    }));
});
var FilterMultiselectOption = function(props) {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* FastField */.Rt, {
        name: props.name,
        children: function(param) {
            var field = param.field, form = param.form;
            var ref;
            var checked = (ref = field.value) === null || ref === void 0 ? void 0 : ref.includes(props.option.value);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton, {
                kind: "text",
                icon: Close/* Close */.x,
                iconProps: {
                    position: "right",
                    size: 10
                },
                onClick: function() {
                    var currentValue = field.value;
                    var anotherValue = props.option.value;
                    if (currentValue == null) {
                        form.setFieldValue(field.name, anotherValue != null ? [
                            anotherValue
                        ] : undefined);
                    } else if (typeof currentValue === "string") {
                        form.setFieldValue(field.name, currentValue === anotherValue ? undefined : [
                            currentValue,
                            anotherValue
                        ]);
                    } else if (currentValue.includes(anotherValue)) {
                        form.setFieldValue(field.name, currentValue.length === 1 && currentValue[0] === anotherValue ? undefined : currentValue.filter(function(v) {
                            return v !== anotherValue;
                        }));
                    } else {
                        form.setFieldValue(field.name, (0,_to_consumable_array/* default */.Z)(currentValue).concat([
                            anotherValue
                        ]));
                    }
                },
                $checked: !!checked,
                $capitalize: props.option.translation,
                children: props.option.translation ? _(props.option.label || "") : props.option.label
            });
        }
    });
};
var FilterMultiselectOptions = function(param) {
    var filter = param.filter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMultiselectOptionsContainer, {
        children: filter.options.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMultiselectOption, {
                name: filter.queryField,
                option: option
            }, option.value);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/filters/FilterTags.tsx

function FilterTags_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 0 6px;\n"
    ]);
    FilterTags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var FilterTagsOptionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterTags__FilterTagsOptionsContainer",
    componentId: "sc-63f50be5-0"
})(FilterTags_templateObject());
var FilterTagsOptions = function(param) {
    var filter = param.filter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTagsOptionsContainer, {
        children: filter.options.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMultiselectOption, {
                name: filter.queryField,
                option: option
            }, option.value);
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/FaceComponent/index.tsx + 1 modules
var FaceComponent = __webpack_require__(41267);
;// CONCATENATED MODULE: ./src/components/filters/FilterFacepart.tsx

function FilterFacepart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(\n    227.25deg,\n    rgba(196, 196, 196, 0) 48.08%,\n    rgba(235, 235, 235, 0.47) 100%\n  );\n\n  margin-left: calc(-1 * var(--left-usable-margin));\n  margin-right: calc(-1 * var(--right-usable-margin));\n  padding-left: 10px;\n  padding-right: 0px;\n\n  ",
        " {\n    overflow: hidden;\n\n    ",
        " {\n      margin-right: -40px;\n    }\n  }\n\n  ",
        " {\n    margin-left: calc(-1 * var(--left-usable-margin));\n    margin-right: calc(-1 * var(--right-usable-margin));\n    padding-left: var(--left-usable-margin);\n    padding-right: var(--right-usable-margin);\n  }\n"
    ]);
    FilterFacepart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FilterFacepartOptionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterFacepart__FilterFacepartOptionsContainer",
    componentId: "sc-847d72e6-0"
})(FilterFacepart_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, FaceComponent/* FaceComponentContainer */.oE, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var FilterFacepartOptions = function(param) {
    var filter = param.filter;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterFacepartOptionsContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaceComponent/* FaceComponentFormik */["in"], {
            small: true,
            name: filter.queryField,
            multi: true
        })
    });
};

;// CONCATENATED MODULE: ./src/components/filters/FilterOptionsDiscriminator.tsx





var FilterOptionsDiscriminator = function(param) {
    var filter = param.filter;
    switch(filter.type){
        case types/* FilterType.Tags */.v.Tags:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTagsOptions, {
                filter: filter
            });
        case types/* FilterType.Multiselect */.v.Multiselect:
        case types/* FilterType.Language */.v.Language:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterMultiselectOptions, {
                filter: filter
            });
        case types/* FilterType.Facepart */.v.Facepart:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterFacepartOptions, {
                filter: filter
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};

;// CONCATENATED MODULE: ./src/components/filters/FilterBlock.tsx

function FilterBlock_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 175%;\n\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  direction: ltr;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    FilterBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterBlock_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    FilterBlock_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterBlock_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'header' 'options';\n  grid-gap: 8px;\n  margin-top: 14px;\n  margin-bottom: 30px;\n"
    ]);
    FilterBlock_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var FiltersBarHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterBlock__FiltersBarHeader",
    componentId: "sc-1be5c4ed-0"
})(FilterBlock_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, theme/* dirRTL */.gX);
var FilterLabel = (0,styled_components_browser_esm["default"])(FiltersBarHeader).withConfig({
    displayName: "FilterBlock__FilterLabel",
    componentId: "sc-1be5c4ed-1"
})(FilterBlock_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var FilterBlockContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterBlock__FilterBlockContainer",
    componentId: "sc-1be5c4ed-2"
})(FilterBlock_templateObject2());
var FilterBlock = function(param) {
    var filter = param.filter;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterBlockContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLabel, {
                children: _(filter.title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterOptionsDiscriminator, {
                filter: filter
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/user/hooks/useUserQuery.ts
var useUserQuery = __webpack_require__(44320);
// EXTERNAL MODULE: ./src/modules/user/hooks/useLanguagesQuery.ts + 1 modules
var useLanguagesQuery = __webpack_require__(53503);
;// CONCATENATED MODULE: ./src/components/filters/FilterLanguageBlock.tsx



function FilterLanguageBlock_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: italic;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 100%;\n  color: ",
        ";\n  margin-bottom: 8px;\n"
    ]);
    FilterLanguageBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var FilterDescriptionBlock = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterLanguageBlock__FilterDescriptionBlock",
    componentId: "sc-91360eeb-0"
})(FilterLanguageBlock_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
});
var FilterLanguageBlock = (0,reactQuery/* withQueries */.kS)({
    user: useUserQuery/* useUserQuery */.b,
    languages: useLanguagesQuery/* useLanguagesQuery */.H
}, function(param) {
    var user = param.user, languages = param.languages, filter = param.filter;
    var _ = (0,lib.useTranslate)()._;
    var userLanguages = user === null || user === void 0 ? void 0 : user.identity.traits.language;
    var selectedLanguages = userLanguages && languages.filter(function(l) {
        return userLanguages.includes(l.code);
    });
    var filteredFilter = (0,react.useMemo)(function() {
        return userLanguages ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filter), {
            options: filter.options.filter(function(l) {
                return !userLanguages.includes(l.value);
            })
        }) : filter;
    }, [
        filter,
        userLanguages
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterBlockContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLabel, {
                        children: _(filter.title)
                    }),
                    (selectedLanguages === null || selectedLanguages === void 0 ? void 0 : selectedLanguages.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterDescriptionBlock, {
                        children: [
                            "from your profile:",
                            " ",
                            selectedLanguages === null || selectedLanguages === void 0 ? void 0 : selectedLanguages.map(function(l, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        i > 0 ? ", " : "",
                                        _(l.name)
                                    ]
                                }, l.code);
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterOptionsDiscriminator, {
                filter: filteredFilter
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/filters/FilterBlockDiscriminator.tsx






var FilterBlockDiscriminator = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(function(param) {
    var filter = param.filter;
    switch(filter.type){
        case types/* FilterType.SearchInput */.v.SearchInput:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterOptionsDiscriminator, {
                filter: filter
            });
        case types/* FilterType.Language */.v.Language:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterLanguageBlock, {
                filter: filter
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBlock, {
                filter: filter
            });
    }
});

;// CONCATENATED MODULE: ./src/components/filters/index.tsx




var Filters = function(query) {
    return (0,reactQuery/* withQueries */.kS)({
        filters: query
    }, function(param) {
        var filters = param.filters;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filters.map(function(filter) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBlockDiscriminator, {
                    filter: filter
                }, filter.queryField);
            })
        });
    }, {
        LoaderComponent: Loader/* Loader */.aN
    });
};

// EXTERNAL MODULE: ./node_modules/react-flip-toolkit/lib/index.es.js + 2 modules
var index_es = __webpack_require__(61557);
;// CONCATENATED MODULE: ./src/components/common/TextChangeTransition.tsx







function getWords(children) {
    var letters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var words = children === null || children === void 0 ? void 0 : children.split(letters ? "" : /(\s)/).filter(function(v) {
        return !!v;
    });
    var keys = words === null || words === void 0 ? void 0 : words.reduce(function(out, word, i) {
        out.counter[word] = out.counter[word] ? out.counter[word] + 1 : 1;
        out.keymap[word + i] = word + out.counter[word];
        return out;
    }, {
        counter: {},
        keymap: {}
    }).keymap;
    return {
        words: words,
        keys: keys
    };
}
var onAppear = function(el) {
    return (0,index_es/* spring */.ST)({
        config: {
            stiffness: 480,
            damping: 42
        },
        onUpdate: function(val) {
            el.style.transform = "translateY(".concat((1 - val) * 10, "px)");
            el.style.opacity = "".concat(val);
        }
    });
};
var springConfig = {
    stiffness: 480,
    damping: 30,
    overshootClamping: true
};
var onExit = function(el, index, removeElement) {
    (0,index_es/* spring */.ST)({
        config: springConfig,
        onUpdate: function(val) {
            el.style.transform = "translateY(-".concat(val * 10, "px)");
            el.style.opacity = "".concat(1 - val);
        },
        onComplete: removeElement
    });
    return function() {
        el.style.opacity = "";
        removeElement();
    };
};
/**
 * @param children
 * @param options
 * @constructor
 */ var TextChangeTransition = function(_param) {
    var children = _param.children, letters = _param.letters, options = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "letters"
    ]);
    var ref = (0,react.useMemo)(function() {
        return getWords(children, letters);
    }, [
        children,
        letters
    ]), words = ref.words, keys = ref.keys;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Flipper */.U5, {
        flipKey: children,
        children: words === null || words === void 0 ? void 0 : words.map(function(word, i) {
            var isSpace = word === " ";
            return /*#__PURE__*/ (0,react.createElement)(index_es/* Flipped */.$3, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onAppear: onAppear,
                onExit: onExit
            }, options), {
                key: keys[word + i],
                flipId: keys[word + i]
            }), /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: isSpace ? "\xa0" : word
            }));
        })
    });
};

// EXTERNAL MODULE: ./src/components/icons/Filter.tsx
var Filter = __webpack_require__(12463);
// EXTERNAL MODULE: ./src/components/common/Input.tsx
var Input = __webpack_require__(81278);
// EXTERNAL MODULE: ./src/components/icons/LookingGlass.tsx
var LookingGlass = __webpack_require__(62702);
;// CONCATENATED MODULE: ./src/components/filters/FilterSearchInput.tsx






function FilterSearchInput(_param) {
    var filter = _param.filter, props = (0,_object_without_properties/* default */.Z)(_param, [
        "filter"
    ]);
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* InputFormik */.FA, (0,_object_spread/* default */.Z)({
        validateOnBlur: true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookingGlass/* default */.Z, {}),
        name: filter.queryField,
        labelSpace: false,
        placeholderVariant: "hide",
        placeholder: _(filter.title)
    }, props));
}

// EXTERNAL MODULE: ./src/components/common/FormikAutoSubmit.tsx + 1 modules
var FormikAutoSubmit = __webpack_require__(30145);
// EXTERNAL MODULE: ./node_modules/clean-deep/src/index.js
var src = __webpack_require__(7826);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/components/ScrollableContent.tsx
var ScrollableContent = __webpack_require__(53402);
// EXTERNAL MODULE: ./vendor/hooks/useLockScroll.tsx + 1 modules
var useLockScroll = __webpack_require__(96110);
// EXTERNAL MODULE: ./node_modules/@summer/jst-react/lib/index.js
var jst_react_lib = __webpack_require__(72559);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/FiltersBar/FiltersBarMobile.tsx




function FiltersBarMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: ",
        "px;\n  grid-template-areas: 'input filtersButton' 'filters filters';\n\n  ",
        " {\n    grid-template-areas: 'input' 'filters';\n  }\n"
    ]);
    FiltersBarMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FiltersBarMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: calc(-1 * var(--left-usable-margin));\n  margin-right: calc(-1 * var(--right-usable-margin));\n  padding-left: var(--left-usable-margin);\n  padding-right: var(--right-usable-margin);\n  ",
        " {\n    margin-right: calc(-1 * var(--left-usable-margin));\n    margin-left: calc(-1 * var(--right-usable-margin));\n    padding-right: var(--left-usable-margin);\n    padding-left: var(--right-usable-margin);\n  }\n"
    ]);
    FiltersBarMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FiltersBarMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 10;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding-right: var(--right-usable-margin);\n  padding-left: var(--left-usable-margin);\n  ",
        " {\n    padding-left: var(--right-usable-margin);\n    padding-right: var(--left-usable-margin);\n  }\n\n  display: grid;\n  grid-template-areas: 'header' 'filters';\n  grid-template-rows: auto 1fr;\n\n  ",
        " {\n    background: ",
        ";\n    padding-top: 20px;\n    ",
        ";\n  }\n"
    ]);
    FiltersBarMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FiltersBarMobile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  overflow: auto;\n  ",
        ";\n  padding-bottom: var(--footer-static-height);\n"
    ]);
    FiltersBarMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FiltersBarMobile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: filtersButton;\n"
    ]);
    FiltersBarMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var SearchQueryInputContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersBarMobile__SearchQueryInputContainer",
    componentId: "sc-ad53a2d8-0"
})(FiltersBarMobile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing.gap;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var extendMargins = (0,styled_components_browser_esm.css)(FiltersBarMobile_templateObject1(), theme/* dirRTL */.gX);
var MobileFiltersContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersBarMobile__MobileFiltersContainer",
    componentId: "sc-ad53a2d8-1"
})(FiltersBarMobile_templateObject2(), theme/* dirRTL */.gX, SearchQueryInputContainer, function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, extendMargins);
var MobileFiltersScrollableArea = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "FiltersBarMobile__MobileFiltersScrollableArea",
    componentId: "sc-ad53a2d8-2"
})(FiltersBarMobile_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, extendMargins);
var StyledMediaDirect = (0,styled_components_browser_esm["default"])(Media/* MediaDirect */.UT).withConfig({
    displayName: "FiltersBarMobile__StyledMediaDirect",
    componentId: "sc-ad53a2d8-3"
})(FiltersBarMobile_templateObject4());
var FiltersBarMobile = function(_param) {
    var onClose = _param.onClose, children = _param.children, containerRef = _param.containerRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose",
        "children",
        "containerRef"
    ]);
    var _ = (0,lib.useTranslate)()._;
    var clientReady = (0,jst_react_lib/* useClientReady */.t0)();
    var position = (0,react.useMemo)(function() {
        var ref;
        return clientReady && ((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) || null;
    }, [
        containerRef,
        clientReady
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFiltersContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            top: position === null || position === void 0 ? void 0 : position.top
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(useLockScroll/* LockScroll */.AS, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchQueryInputContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSearchInput, {
                        filter: {
                            queryField: "q",
                            type: types/* FilterType.SearchInput */.v.SearchInput,
                            title: _("Write a phrase")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* FastField */.Rt, {
                        children: function(param) {
                            var form = param.form;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMediaDirect, {
                                lessThan: "desktop",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    checked: true,
                                    kind: "text",
                                    icon: Close/* Close */.x,
                                    onClick: function() {
                                        onClose();
                                        form.submitForm();
                                    },
                                    iconProps: {
                                        position: "right"
                                    },
                                    children: _("Filters")
                                })
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFiltersScrollableArea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transitions/* motionFadeFromLeftMoreFaster */.TW), {
                children: children
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/FiltersBar/index.tsx



function FiltersBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 20px 0;\n  --left-usable-margin: 20px;\n  --right-usable-margin: 20px;\n\n  ",
        " {\n    flex: 1 1 0;\n    height: calc(100vh - var(--header-fixed-height));\n    // If someone decides that it's super annoying that user cannot scroll all the way to the\n    // filters bar bottom without scrolling over tvbar first, uncomment the two lines below and\n    // add some z-index to tv-bar container.\n    // Side-effect of it is that there will be white padding where tv-bar was\n    // overlapping the filters bar.\n\n    //margin-top: calc(var(--header-fixed-height) - var(--header-static-height));\n    //padding-top: calc(\n    //  20px + var(--header-static-height) - var(--header-fixed-height)\n    //);\n    position: sticky;\n    top: var(--header-fixed-height);\n    display: flex;\n    flex-direction: column;\n    min-height: 600px;\n    margin-left: calc(-1 * var(--constraint-container-left-margin));\n    z-index: 2;\n\n    ",
        " {\n      margin-left: 0;\n      margin-right: calc(-1 * var(--constraint-container-left-margin));\n    }\n\n    & > * {\n      flex: 0 0 auto;\n    }\n\n    & > *:last-child {\n      flex: 1 1 0;\n      position: relative;\n      & > * {\n        ",
        "\n      }\n    }\n\n    padding-right: 5px;\n    padding-bottom: 0;\n\n    &:before {\n      z-index: 0;\n      content: '';\n      position: absolute;\n      width: 100vh;\n      height: 100%;\n      top: 0;\n      right: 0;\n      background: ",
        ";\n\n      ",
        " {\n        right: auto;\n        left: 0;\n      }\n    }\n  }\n"
    ]);
    FiltersBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FiltersBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding-left: var(--constraint-container-left-margin);\n    --left-usable-margin: var(--constraint-container-left-margin);\n\n    padding-right: 30px;\n    --right-usable-margin: 30px;\n    ",
        " {\n      padding-right: var(--constraint-container-left-margin);\n      padding-left: 30px;\n    }\n  }\n"
    ]);
    FiltersBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FiltersBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: ",
        "px;\n  grid-template-areas: 'input filtersButton' 'filters filters';\n\n  ",
        " {\n    grid-template-areas: 'input' 'filters';\n  }\n"
    ]);
    FiltersBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FiltersBar_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  ",
        " {\n    margin-left: 0;\n    margin-right: 10px;\n  }\n"
    ]);
    FiltersBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function FiltersBar_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    FiltersBar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function FiltersBar_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n"
    ]);
    FiltersBar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function FiltersBar_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: filtersButton;\n"
    ]);
    FiltersBar_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






















var FiltersContainer = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "FiltersBar__FiltersContainer",
    componentId: "sc-1372a034-0"
})(FiltersBar_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, styles_common/* layer */.EY, function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, theme/* dirRTL */.gX);
var FiltersBarInnerPadding = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersBar__FiltersBarInnerPadding",
    componentId: "sc-1372a034-1"
})(FiltersBar_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX);
var FiltersBar_SearchQueryInputContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersBar__SearchQueryInputContainer",
    componentId: "sc-1372a034-2"
})(FiltersBar_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing.gap;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ClearButtonWrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "FiltersBar__ClearButtonWrapper",
    componentId: "sc-1372a034-3"
})(FiltersBar_templateObject3(), theme/* dirRTL */.gX);
var keywordsTransitionProps = {
    initial: {
        opacity: 0,
        y: 10
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            delay: 0.1
        }
    },
    exit: {
        opacity: 0,
        x: 40
    },
    transition: springConfig
};
var Row = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersBar__Row",
    componentId: "sc-1372a034-4"
})(FiltersBar_templateObject4());
var StyledFilterSearchInput = (0,styled_components_browser_esm["default"])(FilterSearchInput).withConfig({
    displayName: "FiltersBar__StyledFilterSearchInput",
    componentId: "sc-1372a034-5"
})(FiltersBar_templateObject5());
var FiltersBar_StyledMediaDirect = (0,styled_components_browser_esm["default"])(Media/* MediaDirect */.UT).withConfig({
    displayName: "FiltersBar__StyledMediaDirect",
    componentId: "sc-1372a034-6"
})(FiltersBar_templateObject6());
var getSelectedFiltersCount = memoizee_default()(function(filters) {
    return Object.values(src_default()((0,rambda_esm.omit)("showcase", filters))).filter(function(v) {
        return Array.isArray(v) ? v.length > 0 : !!v;
    }).length;
}, {
    max: 1
});
var FiltersBar = function(param) {
    var children = param.children;
    var _ = (0,lib.useTranslate)()._;
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), filtersMobileOpen = ref[0], setFiltersMobileOpen = ref[1];
    var toggleFilters = function() {
        return setFiltersMobileOpen(function(v) {
            return !v;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FiltersContainer, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FiltersBarInnerPadding, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                        children: function(param) {
                            var form = param.form;
                            var selectedFiltersCount = getSelectedFiltersCount(form.values);
                            var clearFilters = function() {
                                form.setValues({});
                            };
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* MediaDirect */.UT, {
                                    greaterThanOrEqual: "desktop",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBarHeader, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextChangeTransition, {
                                                letters: true,
                                                children: selectedFiltersCount > 0 ? _("Filters ({count})", undefined, {
                                                    count: selectedFiltersCount
                                                }) : _("Filters")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                            children: selectedFiltersCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearButtonWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, keywordsTransitionProps), {
                                                layout: "position",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                                    kind: "text",
                                                    variant: "underline",
                                                    onClick: clearFilters,
                                                    children: _("clear all")
                                                })
                                            }))
                                        })
                                    ]
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBar_SearchQueryInputContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FiltersBar_StyledMediaDirect, {
                            lessThan: "desktop",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSearchInput, {
                                    filter: {
                                        queryField: "q",
                                        type: types/* FilterType.SearchInput */.v.SearchInput,
                                        title: _("Write a phrase")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    kind: "text",
                                    icon: Filter/* default */.Z,
                                    onClick: toggleFilters,
                                    iconProps: {
                                        position: "right"
                                    },
                                    children: _("Filters")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: filtersMobileOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                    lessThan: "desktop",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBarMobile, {
                        containerRef: containerRef,
                        onClose: toggleFilters,
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Media/* MediaDirect */.UT, {
                greaterThanOrEqual: "desktop",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContent/* ScrollableContent */.t, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FiltersBarInnerPadding, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                                        greaterThanOrEqual: "desktop",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilterSearchInput, {
                                            filter: {
                                                queryField: "q",
                                                type: types/* FilterType.SearchInput */.v.SearchInput,
                                                title: _("Write a phrase")
                                            }
                                        })
                                    }),
                                    children
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikAutoSubmit/* FormikAutoSubmit */.U, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/usePushAnalyticsEvent.tsx + 1 modules
var usePushAnalyticsEvent = __webpack_require__(41569);
;// CONCATENATED MODULE: ./src/modules/materials/components/ShowcasePage/index.tsx




function ShowcasePage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n\n  ",
        " {\n    margin-bottom: calc(-1 * (161px));\n\n    ",
        " {\n      margin-bottom: calc(-1 * (100px));\n    }\n\n    ",
        " {\n      margin-bottom: calc(150px);\n      ",
        " {\n        margin-bottom: calc(100px);\n      }\n    }\n  }\n"
    ]);
    ShowcasePage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShowcasePage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 auto;\n\n  ",
        " {\n    display: grid;\n    grid-template-areas: 'filters results';\n    grid-template-columns: 300px 1fr;\n  }\n"
    ]);
    ShowcasePage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var PageConstraintContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "ShowcasePage__PageConstraintContainer",
    componentId: "sc-d6dab07e-0"
})(ShowcasePage_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, ResultsContainer, theme/* dirRTL */.gX);
var Results = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShowcasePage__Results",
    componentId: "sc-d6dab07e-1"
})(ShowcasePage_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ShowcasePageTemplate = function(_param) {
    var filtersQuery = _param.filtersQuery, sectionsQuery = _param.sectionsQuery, props = (0,_object_without_properties/* default */.Z)(_param, [
        "filtersQuery",
        "sectionsQuery"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(useQueryParams(), 2), params = ref[0], setParams = ref[1];
    var showcaseFilterParamsKeys = (0,react.useMemo)(function() {
        var _itemsToQuery;
        var itemsToQuery = (_itemsToQuery = props.itemsToQuery) !== null && _itemsToQuery !== void 0 ? _itemsToQuery : Object.keys(search/* searchFiltersToQueryMap */.IA);
        return itemsToQuery.reduce(function(prev, curr) {
            return prev.concat(Object.keys(search/* searchFiltersToQueryMap */.IA[curr]));
        }, []);
    }, [
        props.itemsToQuery
    ]);
    var queryParamsFilters = (0,react.useMemo)(function() {
        return (0,rambda_esm.pick)(showcaseFilterParamsKeys, params);
    }, [
        params,
        showcaseFilterParamsKeys
    ]);
    var ref1 = (0,react.useState)(queryParamsFilters), filterState = ref1[0], setFilterState = ref1[1];
    var pushEvent = (0,usePushAnalyticsEvent/* usePushAnalyticsEvent */.C)();
    (0,useUpdateEffect/* default */.Z)(function() {
        var otherParams = (0,rambda_esm.omit)(showcaseFilterParamsKeys, params);
        setParams((0,_object_spread/* default */.Z)({}, otherParams, filterState));
    }, [
        filterState
    ]);
    (0,useUpdateEffect/* default */.Z)(function() {
        setFilterState(queryParamsFilters);
    }, [
        queryParamsFilters
    ]);
    (0,useUpdateEffect/* default */.Z)(function() {
        filterState.q && pushEvent(usePushAnalyticsEvent/* AnalyticsEvent.Search */.s.Search, {
            phrase: filterState.q.toString()
        });
    }, [
        filterState.q,
        pushEvent
    ]);
    var ShowcaseFilters = (0,react.useMemo)(function() {
        return Filters(filtersQuery);
    }, [
        filtersQuery
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseContext/* ShowcaseContext.Provider */.r.Provider, {
        value: props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageConstraintContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Results, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        enableReinitialize: true,
                        initialValues: queryParamsFilters,
                        onSubmit: function(data, form) {
                            setFilterState((0,rambda_esm.omit)(search/* searchFiltersExceptions */.Z8, data));
                            form.setSubmitting(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBar, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseFilters, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseGallery, {
                        filters: filterState,
                        sectionsQuery: sectionsQuery
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 86649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ SliderSectionRender; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_hooks_dev_useFastRefreshFixer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78162);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52178);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72873);
/* harmony import */ var src_modules_materials_components_Thumbnail__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87847);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10395);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68251);
/* harmony import */ var src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18709);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38108);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(87379);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78296);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12258);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79017);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38325);
/* harmony import */ var src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47536);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_hooks_useIsRTL__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36311);
/* harmony import */ var src_modules_materials_providers_TaxonomyContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(74729);
/* harmony import */ var src_modules_materials_providers_ShowcaseContext__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(54095);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(81041);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(14332);
/* harmony import */ var src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(84176);
/* harmony import */ var src_hooks_useDelayedValue__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(12230);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: var(--results-left-margin);\n  padding-right: calc(var(--constraint-container-right-margin) - 20px);\n  ",
        " {\n    padding-left: calc(var(--constraint-container-right-margin) - 20px);\n    padding-right: var(--results-left-margin);\n  }\n\n  .swiper-slide {\n    width: 264px;\n    min-height: 220px;\n    margin-right: 20px;\n    ",
        " {\n      margin-right: 0;\n      margin-left: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  margin: 0 calc(-1 * var(--results-right-margin)) 40px\n    calc(-1 * var(--results-left-margin));\n  ",
        " {\n    opacity: 0;\n  }\n  &:hover > ",
        " {\n    opacity: 1;\n  }\n  ",
        " {\n    margin: 0 calc(-1 * var(--results-left-margin)) 42px\n      calc(-1 * var(--results-right-margin));\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
























var StyledSwiper = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__["default"])(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .t).withConfig({
    displayName: "SliderSectionRender__StyledSwiper",
    componentId: "sc-b208bfaf-0"
})(_templateObject(), src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX, src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX);
var SkeletonSlide = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_23__/* .motion.div */ .E.div).withConfig({
    displayName: "SliderSectionRender__SkeletonSlide",
    componentId: "sc-b208bfaf-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
});
var SwiperArea = styled_components__WEBPACK_IMPORTED_MODULE_22__["default"].div.withConfig({
    displayName: "SliderSectionRender__SwiperArea",
    componentId: "sc-b208bfaf-2"
})(_templateObject2(), src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX);
var SeeAllContainer = styled_components__WEBPACK_IMPORTED_MODULE_22__["default"].div.withConfig({
    displayName: "SliderSectionRender__SeeAllContainer",
    componentId: "sc-b208bfaf-3"
})(_templateObject3(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_12__.ar)(16 / 9));
var SeeAllButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx).withConfig({
    displayName: "SliderSectionRender__SeeAllButton",
    componentId: "sc-b208bfaf-4"
})(_templateObject4());
var SliderSectionRender = function(param) {
    var section = param.section, items = param.items, event = param.event, _header = param.header, header = _header === void 0 ? true : _header, isLoading = param.isLoading;
    var ref, ref1;
    var key = (0,src_hooks_dev_useFastRefreshFixer__WEBPACK_IMPORTED_MODULE_2__/* .useFastRefreshFixer */ .P)();
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), swiper = ref2[0], setSwiper = ref2[1];
    var thumbnailOptions = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(src_modules_materials_providers_ShowcaseContext__WEBPACK_IMPORTED_MODULE_19__/* .ShowcaseContext */ .r).thumbnailOptions;
    var isRTL = (0,src_hooks_useIsRTL__WEBPACK_IMPORTED_MODULE_17__/* .useIsRTL */ .S)();
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_24__.useTranslate)()._;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    var hasItems = isLoading || items != null && items.length > 0;
    var loading = (0,src_hooks_useDelayedValue__WEBPACK_IMPORTED_MODULE_21__/* .useDelayedValue */ .t)(isLoading, 500);
    var shouldDisplaySeeAllBtn = !!(section.searchQuery && ((ref = section.variables) === null || ref === void 0 ? void 0 : ref.limit) && items && items.length >= section.variables.limit);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_modules_materials_providers_TaxonomyContext__WEBPACK_IMPORTED_MODULE_18__/* .TaxonomyContext.Provider */ .u.Provider, {
        value: section.taxonomy,
        children: [
            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .GenericSectionHeader */ .O, {
                section: section
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperArea, {
                children: hasItems && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSwiper, {
                            threshold: 15,
                            onSwiper: setSwiper,
                            slidesPerView: "auto",
                            watchSlidesProgress: true,
                            navigation: {
                                prevEl: prevRef.current,
                                nextEl: nextRef.current
                            },
                            wrapperTag: "ul",
                            children: [
                                (ref1 = items !== null && items !== void 0 ? items : lodash_range__WEBPACK_IMPORTED_MODULE_16___default()(5)) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o, {
                                        tag: "li",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_25__/* .AnimatePresence */ .M, {
                                            children: [
                                                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonSlide, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, (0,src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_20__/* .makeTransition */ .Vr)({
                                                    fade: true
                                                })), {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_15__/* .Skeleton */ .O, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_15__/* .Skeleton */ .O, {
                                                            style: {
                                                                marginTop: 14
                                                            },
                                                            width: "60%",
                                                            height: "20px"
                                                        })
                                                    ]
                                                }), "skeleton-".concat(i)),
                                                typeof item !== "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_Thumbnail__WEBPACK_IMPORTED_MODULE_6__/* .Thumbnail */ .$, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({
                                                    item: item,
                                                    event: event,
                                                    uniqueId: item.id + section.name
                                                }, thumbnailOptions))
                                            ]
                                        })
                                    }, i);
                                }),
                                section.searchQuery && shouldDisplaySeeAllBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o, {
                                    tag: "li",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SeeAllContainer, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_13__/* .TrackedLink */ .A, {
                                            href: src_services_route__WEBPACK_IMPORTED_MODULE_14__/* .route.search */ .BC.search(section.searchQuery).all(true),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SeeAllButton, {
                                                forwardedAs: "a",
                                                icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_10__/* .ChevronRight */ ._,
                                                iconProps: {
                                                    position: "right",
                                                    size: 12
                                                },
                                                children: _("See all")
                                            })
                                        })
                                    })
                                })
                            ]
                        }, key),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_7__/* .Theme */ .Q, {
                            theme: src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .darkTheme */ .$_,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, {
                                    kind: "circled",
                                    ref: prevRef,
                                    icon: src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_9__/* .ChevronLeft */ .s,
                                    $direction: "left"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, {
                                    kind: "circled",
                                    ref: nextRef,
                                    icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_10__/* .ChevronRight */ ._,
                                    $direction: "right"
                                })
                            ]
                        })
                    ]
                })
            }, String(isRTL) + key)
        ]
    });
};


/***/ }),

/***/ 61012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ speakersGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment speakers on people {\n    id\n    avatar {\n      id\n    }\n    name\n    translations {\n      degree\n      title\n      languages_code {\n        code\n      }\n    }\n    country {\n      translations {\n        languages_code {\n          code\n        }\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var speakersGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 80614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ShowcaseSection; }
/* harmony export */ });
var ShowcaseSection;
(function(ShowcaseSection) {
    ShowcaseSection["SearchResults"] = "searchResults";
    ShowcaseSection["List"] = "list";
    ShowcaseSection["Favorites"] = "favorites";
    ShowcaseSection["HeroList"] = "heroList";
    ShowcaseSection["ProtocolTreatment"] = "protocolTreatment";
    ShowcaseSection["BusinessCases"] = "businessCases";
})(ShowcaseSection || (ShowcaseSection = {}));


/***/ }),

/***/ 53503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useLanguagesQuery; }
});

// UNUSED EXPORTS: fetchLanguages

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/user/graphql/languages.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query {\n    languages(limit: -1) {\n      code\n      name\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var languagesGqlQuery = (0,query/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var models_query = __webpack_require__(19162);
;// CONCATENATED MODULE: ./src/modules/user/hooks/useLanguagesQuery.ts






var fetchLanguages = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(languagesGqlQuery).then(function(a) {
                            return a.languages;
                        })
                    ];
            }
        });
    });
    return function fetchLanguages(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useLanguagesQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(models_query/* QueryKey.ProfileLanguages */.S.ProfileLanguages, function() {
        return fetchLanguages(apis);
    }, {
        refetchOnMount: false,
        keepPreviousData: true,
        refetchOnReconnect: false
    });
};


/***/ }),

/***/ 77336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ videosBasicGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);
/* harmony import */ var src_modules_videos_graphql_videos_basic_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3273);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  query VideoBasicQuery($filters: videos_filter, $sort: [String], $limit: Int) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      ...videosBasic\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var videosBasicGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), src_modules_videos_graphql_videos_basic_fragment__WEBPACK_IMPORTED_MODULE_2__/* .videosBasicFragment */ .B);


/***/ }),

/***/ 68591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ videoDetailsGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61012);
/* harmony import */ var src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70763);
/* harmony import */ var src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39738);
/* harmony import */ var src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67561);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query VideoDetailsQuery(\n    $filters: videos_filter\n    $sort: [String]\n    $limit: Int\n  ) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      id\n      slug\n      date_created\n\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      translations {\n        languages_code {\n          code\n        }\n        name\n        description\n        excerpt\n      }\n      audioLanguages {\n        languages_code {\n          code\n          name\n        }\n      }\n      thumbnail {\n        id\n      }\n      products {\n        products_id {\n          ...products\n        }\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n        startDate\n        endDate\n      }\n      tags {\n        tags_id {\n          ...tags\n        }\n      }\n      shortcodes {\n        ...shortcodes\n      }\n      speakers {\n        people_id {\n          ...speakers\n        }\n      }\n      attachments {\n        attachments_id {\n          id\n          type\n          translations {\n            name\n            url\n            description\n            file {\n              id\n            }\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var videoDetailsGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(_templateObject(), src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__/* .productsGqlFragment */ .f, src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__/* .shortcodesGqlFragment */ .U, src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__/* .speakersGqlFragment */ .v, src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__/* .tagsGqlFragment */ .i);


/***/ }),

/***/ 24332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useVideosListQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53100);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19162);






var useVideosListQuery = function(query, variables, options) {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_0__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.VideoList */ .S.VideoList).concat([
        query,
        variables
    ]), /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var directus;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(query, variables).then(function(d) {
                            return d.videos.filter(function(v) {
                                return v;
                            });
                        })
                    ];
            }
        });
    }), options);
};


/***/ }),

/***/ 12356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ videoQueryByIdFactory; },
/* harmony export */   "fP": function() { return /* binding */ videoQueryByIdOrSlugFactory; }
/* harmony export */ });
/* unused harmony exports videoQueryFactory, videoQueryBySlugFactory */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20414);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19162);
/* harmony import */ var src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57750);
/* harmony import */ var src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68591);








var videoQueryFactory = function(apis, filters) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_1__/* .queryCommonOptions.longStale */ .e.longStale), {
        queryKey: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.Video */ .S.Video).concat([
            filters
        ]),
        queryFn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var directus;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            2,
                            directus.query(src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__/* .videoDetailsGqlQuery */ .W, {
                                filters: filters
                            }).then(function(a) {
                                return a.videos[0];
                            })
                        ];
                }
            });
        })
    });
};
var videoQueryByIdFactory = function(apis, videoId) {
    return videoQueryFactory(apis, {
        id: {
            _eq: videoId
        }
    });
};
var videoQueryBySlugFactory = function(apis, slug) {
    return videoQueryFactory(apis, {
        slug: {
            _eq: slug
        }
    });
};
var UUIDRegExp = /^[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}$/;
var videoQueryByIdOrSlugFactory = function(apis, videoIdOrSlug) {
    return UUIDRegExp.test(videoIdOrSlug) ? videoQueryByIdFactory(apis, videoIdOrSlug) : videoQueryBySlugFactory(apis, videoIdOrSlug);
};


/***/ }),

/***/ 89755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ valueFromTargetDataset; }
/* harmony export */ });
/* unused harmony export valueFromTargetValue */
/**
 *  const selectTab = valueFromTargetDataset('value')((value) => {
 *    console.log(value); // value = "DETAILS"
 *  });
 *
 *  <button data-value="DETAILS" onClick={selectTab}/>
 *
 * @param datasetKey
 */ var valueFromTargetDataset = function(datasetKey) {
    return function(handler) {
        return function(e) {
            return handler(e.currentTarget.dataset[datasetKey]);
        };
    };
};
/**
 *  const selectTab =
 *  valueFromTargetValue((value) => {
 *    console.log(value); // value = "DETAILS"
 *  });
 *
 *  <select onChange={selectTab}>
 *    <option value="DETAILS"/>
 *  </select>
 *
 * @param handler
 */ var valueFromTargetValue = function(handler) {
    return function(e) {
        return handler(e.currentTarget.value);
    };
};


/***/ })

}]);